jQuery(($) => {
    if ($(".m-audio-player")[0]) {
        Plyr.setup('.m-audio-player__audio', {
            type: 'audio',
            controls: ['play', 'current-time', 'progress', 'duration', 'mute', 'volume'],
            loadSprite: false
        });
    }
});